<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="100px">
          <el-form-item label="客户支付金额:" >
            <span style="font-size: 18px;color: #0a65f0;">{{form.actualPayableFee}}元</span>
          </el-form-item>
          <el-form-item label="退款金额:" prop="refundAmount">
            <el-input
              v-model="form.refundAmount"
              clearable
              autocomplete="off"
              :placeholder="`请输入小于等于${form.actualPayableFee}元`"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { priceReg } from "@/utils/validate";
import { cancelOrder } from "@/views/OrderManagement/api";
export default {
  name: "CancelOrReassignment",
  components: {
    DialogContainer,
  },
  data() {
    var  validatePrice = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      if (!priceReg.test(value)) {
        return callback(new Error("请正确输入，保留两位小数"));
      } else {
        if (Number(this.form.refundAmount) > Number(this.form.actualPayableFee)) {
          return callback(new Error(`请输入小于等于${this.form.actualPayableFee}元`));
        } else {
          callback();
        }
      }
    }
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "订单取消",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        orderId: "",
        actualPayableFee: "",
        refundAmount: "",
      },
      rules: {
        refundAmount: [
          { required: true, message: "金额不能为空", trigger: "change" },
          { validator: validatePrice, trigger: "change" },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    init(detail) {
      this.form.orderId = detail.orderId;
      this.form.actualPayableFee = detail.actualPayableFee;
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            orderId: this.form.orderId,
            refundAmount: this.form.refundAmount,
          };
          cancelOrder(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("订单取消成功");
                this.$emit("success");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1269ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
</style>
